<template>
    <v-row dense>
        <v-col cols="12" md="12">
            <v-card variant="outlined">
                <v-card-title>
                    <span class="font-weight-bold text-subtitle-2">
                        {{ $t('calculate_discount_from') }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-radio-group v-model="calculationType" hide-details>
                        <v-radio
                            v-for="type in useDiscountCalculationType"
                            :key="type.value"
                            :value="type.value"
                            :label="type.title"
                        />
                    </v-radio-group>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    const calculationType = defineModel<string>()

    const {t} = useI18n()

    const useDiscountCalculationType = computed(() => {
        return ['MEAL_PLACE', 'PLACE_ONLY', 'MEAL_ONLY'].map(value => ({
            title: t(`discountCalculationType.${value}`),
            value: value,
        }))
    })
</script>
